import { useState } from "react";
import { motion } from "framer-motion";
import { TiltCard } from "@/components/site/TiltCard";
import { Reveal } from "@/components/site/Reveal";
import { STEPS } from "@/data/site";

const StepCard = ({ step, index }) => {
  const [hover, setHover] = useState(false);
  return (
    <Reveal delay={index * 0.08} className="h-full">
      <TiltCard
        max={5}
        className="h-full"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        data-cursor-color={step.color}
      >
        <div
          data-testid={`step-${step.n}`}
          className="flex h-full flex-col border border-hair p-8 transition-colors duration-300"
          style={{ backgroundColor: hover ? `${step.color}12` : "#FFFFFF" }}
        >
          <motion.span
            className="font-heading text-5xl font-black leading-none tracking-tight"
            style={{ color: step.color }}
            animate={{ y: hover ? -4 : 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 18 }}
          >
            {step.n}
          </motion.span>
          <h3 className="mt-6 font-heading text-2xl font-bold text-ink md:text-3xl">{step.title}</h3>
          <p className="mt-3 text-base leading-relaxed text-graphite">{step.body}</p>
        </div>
      </TiltCard>
    </Reveal>
  );
};

export const Philosophy = () => {
  return (
    <section id="values" data-testid="section-values" className="border-t border-hair py-12 md:py-20">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <Reveal>
          <span className="eyebrow">Filozofia kampanii</span>
          <h2 className="mt-4 max-w-3xl font-heading text-4xl font-bold leading-[1.02] tracking-tight text-ink md:text-6xl">
            Cztery kroki, nieskończoność możliwości
          </h2>
        </Reveal>

        {/* Insight / Idea */}
        <div className="mt-16 grid grid-cols-1 border border-hair md:grid-cols-2">
          <Reveal className="relative overflow-hidden">
            <div className="owo-dots-bg absolute inset-0 opacity-60" aria-hidden />
            <div className="relative flex h-full flex-col justify-between bg-white p-8 md:p-12">
              <span className="eyebrow" style={{ color: "#F59BBB" }}>
                Insight
              </span>
              <div className="mt-10">
                <p className="font-heading text-2xl font-bold leading-tight text-ink md:text-3xl">
                  Dzieci nie potrzebują kolejnego ekranu. Potrzebują przestrzeni na wyobraźnię.
                </p>
                <p className="mt-5 text-base leading-relaxed text-graphite">
                  OWOCAPS to mały gest w stronę wielkiej zmiany: mniej biernego scrollowania, więcej
                  tworzenia. Mniej gotowych bodźców, więcej własnych pomysłów. Mniej „daj mi telefon",
                  więcej „zobacz, co zbudowałem".
                </p>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.1} className="relative overflow-hidden">
            <div className="owo-dots-bg absolute inset-0 opacity-60" aria-hidden />
            <div className="relative flex h-full flex-col justify-between bg-owo-pink p-8 md:p-12">
              <span className="eyebrow" style={{ color: "#0A0A0A" }}>
                Idea
              </span>
              <div className="mt-10">
                <p className="font-heading text-2xl font-bold leading-tight text-ink md:text-3xl">
                  Filozofia COLLECT &amp; PLAY
                </p>
                <p className="mt-5 text-base leading-relaxed text-ink/80">
                  OWOCAPS opierają się na prostej, ale silnej mechanice: collect &amp; play. Każdy mus
                  OWOLOVO daje dziecku kolejny element do kolekcji. Im więcej zakrętek, tym większe
                  konstrukcje, więcej możliwości i więcej powodów, żeby wracać po kolejne smaki.
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        {/* Four steps */}
        <div className="mt-8 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <StepCard key={s.n} step={s} index={i} />
          ))}
        </div>

        {/* Configurator removed */}
      </div>
    </section>
  );
};
